import axios from "../axios-auth";

export const shiftAssignService = {
  getShiftAssignList,
  getShiftAssignDetail,
  saveShiftAssign
};

function getShiftAssignList(searchParams, page, size ,sortedBy) {
  if(!page){
      page = 0;
  }
  else{
      page -= 1;
  }
  if(!size){
      size = 50;
  }
  let url = '/auth/shift-assigns?page='+page+'&size='+size+'&sort='+sortedBy;
  if (searchParams.assignDate) {
      url += '&assignDate=' + searchParams.assignDate;
  }
  if(searchParams.shiftInfoId){
      url += '&shiftInfoId=' + searchParams.shiftInfoId;
  }
  if(searchParams.shopId){
    url += '&shopId=' + searchParams.shopId;
  }
  return axios.get(url);
}

function saveShiftAssign(shiftAssign) {
  if (!shiftAssign.id) {
    // new shiftInfo
    return axios.post("/auth/shift-assign", shiftAssign);
  } else {
    // edit
    return axios.put("/auth/shift-assign", shiftAssign);
  }
}

function getShiftAssignDetail(id) {
  return axios.get('/auth/shift-assign/' + id);
}